export default "__VITE_ASSET__3U$r8lbj__"